import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizContainer } = framework_tool
import 'antd/dist/antd.css';
let { WizSpin, WizButton, WizRow, WizCol, WizModal, WizCheckbox, WizRadio } = component_tool;
import { WizTableForm } from '@/containers/common'
import './index.less'
class BatchUpdate extends WizContainer {
  componentName = 'newVersion'

  constructor(props) {
    super(props)
    this.state = {
      record: this.props.record,
      flagList: [1, 2],
      categoryOperateType: 1,
      labelOperateType: 1,
      oldCategoryIdList: [],
      newCategoryIdList: [],
      oldLabelIdList: [],
      newLabelIdList: [],
    };
  }

  _componentDidMount() {

  }


  batchAuditRecord = (params) => {
    this.doAction({
      path: 'proKnowledge/batchUpdate',
      payload: {
        key: 'proKnowledge@batchUpdate',
        apiParams: {
          ...params
        }
      }
    })
  }

  propsAndStateOnChange = {
    batchUpdateInfo: this._handleBatchUpdateCMD.bind(this),
  }

  _onCancel=() => {
    this.setState({
      record: {},
      flagList: [1, 2],
      categoryOperateType: 1,
      labelOperateType: 1,
      oldCategoryIdList: [],
      newCategoryIdList: [],
      oldLabelIdList: [],
      newLabelIdList: [],
      keepDoItFlag: 0,
    })
  }

  _onOk = () => {
    let { record, flagList, categoryOperateType, labelOperateType, oldCategoryIdList, newCategoryIdList, oldLabelIdList, newLabelIdList } = this.state
    if (!flagList.length) {
      wizNotice.error("请选择需要修改的属性!")
      return false
    }
    //选择了分类
    if (flagList.indexOf(1) != -1) {
      if (categoryOperateType == 1 && !newCategoryIdList.length) {
        wizNotice.error("请选择新增的分类!")
        return false
      }
      if (categoryOperateType == 3 && !oldCategoryIdList.length) {
        wizNotice.error("请选择删除的分类!")
        return false
      }
      if (categoryOperateType == 2 && !newCategoryIdList.length) {
        wizNotice.error("请选择新的分类!")
        return false
      }
      if (categoryOperateType == 2 && !oldCategoryIdList.length) {
        wizNotice.error("请选择需要替换的分类!")
        return false
      }
    }
    //选择了标签
    if (flagList.indexOf(2) != -1) {
      if (labelOperateType == 1 && !newLabelIdList.length) {
        wizNotice.error("请选择新增的标签!")
        return false
      }
      if (labelOperateType == 3 && !oldLabelIdList.length) {
        wizNotice.error("请选择删除的标签!")
        return false
      }
      if (labelOperateType == 2 && !newLabelIdList.length) {
        wizNotice.error("请选择新的标签!")
        return false
      }
      if (categoryOperateType == 2 && !oldLabelIdList.length) {
        wizNotice.error("请选择需要替换的标签!")
        return false
      }
    }
    let idList = [];
    record.forEach(element => {
      idList.push(element.id);
    });
    let params = { idList, flagList, categoryOperateType, labelOperateType, oldCategoryIdList, newCategoryIdList, oldLabelIdList, newLabelIdList, keepDoItFlag: 0 }
    this.batchAuditRecord(params)
  }


  _handleBatchUpdateCMD(nextProps, nextState, key) {
    let o = nextProps.batchUpdateInfo
    if (o['success']) {
      if (o.data.flag === 0) {
        let { record, flagList, categoryOperateType, labelOperateType, oldCategoryIdList, newCategoryIdList, oldLabelIdList, newLabelIdList } = this.state
        let idList = [];
        record.forEach(element => {
          idList.push(element.id);
        });
        let apiParams = {
          flagList, categoryOperateType, labelOperateType, oldCategoryIdList, newCategoryIdList, oldLabelIdList, newLabelIdList, keepDoItFlag: 1, idList
        }
        WizModal.confirm({
          title: "注意",
          content: o.data.msg,
          onOk: () => {
            this.doAction({
              path: 'proKnowledge/batchUpdate',
              payload: {
                key: 'proKnowledge@batchUpdate',
                apiParams: {
                  ...apiParams
                }
              }
            })
          },
          onCancel() {
          },
        });
      } else {
        this.props.changeModal(false, true, true)
        wizNotice.success(o['msg'])
      }
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  render() {
    let record = this.state.record
    let hasCategoryIds = [];
    let hasLableIds = [];
    record && record.length && record.forEach(e=>{
      let categoryIdList = e.categoryIdList;
      let labelIdList = e.labelIdList;
      hasCategoryIds=[...categoryIdList,...hasCategoryIds];
      hasLableIds=[...labelIdList,...hasLableIds];
    })
    let oldCategoryName = this.state.categoryOperateType == 2 ? "需要替换的分类：" : "需要删除的分类：";
    let newCategoryName = this.state.categoryOperateType == 2 ? "新的分类：" : "新增的分类：";
    let oldLabledName = this.state.labelOperateType == 2 ? "需要替换的标签：" : "需要删除的标签：";
    let newLableName = this.state.labelOperateType == 2 ? "新的标签：" : "新增的标签：";
    return <>
      <div className="batchSetModal">
        <WizRow className="modal-row">
          <WizCol span={7} className="modal-col">
            <span><font style={{ 'color': 'red' }}> 提醒：</font></span>
          </WizCol>
          <WizCol span={12} className="modal-col-right">
            <span><font style={{ 'color': 'red' }}>当前共选择了{record.length}个知识，请选择需要修改的知识属性</font> </span>
          </WizCol>
        </WizRow>
        <WizRow className="modal-row">
          <WizCol span={7} className="modal-col">
            <span>请选择需要修改的属性：</span>
          </WizCol>
          <WizCol span={12} className="modal-col-right">
            <WizCheckbox.Group defaultValue={[1, 2]} onChange={(e) => { this.setState({ flagList: e }) }}>
              <WizCheckbox value={1}>分类</WizCheckbox>
              <WizCheckbox value={2}>标签</WizCheckbox>
            </WizCheckbox.Group>
          </WizCol>
        </WizRow>
        {this.state.flagList.indexOf(1) != -1 ? <>
          <WizRow className="modal-row" style={{ marginTop: 20 }}>
            <WizCol span={7} className="modal-col">
              <span><font style={{ 'color': 'red' }}>*</font> 分类：</span>
            </WizCol>
            <WizCol span={12} className="modal-col-right">
              <WizRadio.Group defaultValue={1} onChange={(e) => { this.setState({ categoryOperateType: e.target.value }) }}>
                <WizRadio value={1}>新增分类</WizRadio>
                <WizRadio value={2}>替换分类</WizRadio>
                <WizRadio value={3}>删除分类</WizRadio>
              </WizRadio.Group>
            </WizCol>
          </WizRow>
          {this.state.categoryOperateType == 3 || this.state.categoryOperateType == 2 ?
            <WizRow className="modal-row">
              <WizCol span={7} className="modal-col">
                <span><font style={{ 'color': 'red' }}>*</font> {oldCategoryName}</span>
              </WizCol>
              <WizCol span={12} className="modal-col-right">
                <WizTableForm
                  onChange={(e) => { this.setState({ oldCategoryIdList: e }) }}
                  key={'categoryInfo1'} {...WizTableForm.Config.categoryInfo(this, { apiParams: { type: 18, state: 1,idList:hasCategoryIds } })} />
              </WizCol>
            </WizRow> : <></>
          }
          {this.state.categoryOperateType == 1 || this.state.categoryOperateType == 2 ?
            <WizRow className="modal-row">
              <WizCol span={7} className="modal-col">
                <span><font style={{ 'color': 'red' }}>*</font> {newCategoryName}</span>
              </WizCol>
              <WizCol span={12} className="modal-col-right">
                <WizTableForm
                  onChange={(e) => { this.setState({ newCategoryIdList: e }) }}
                  key={'categoryInfo2'} {...WizTableForm.Config.categoryInfo(this, { apiParams: { type: 18, state: 1,categoryName:'产品知识',sceneType:125 } })} />
              </WizCol>
            </WizRow> : <></>
          }
        </> : <></>}
        {this.state.flagList.indexOf(2) != -1 ? <>
          <WizRow className="modal-row" style={{ marginTop: 40 }}>
            <WizCol span={7} className="modal-col">
              <span><font style={{ 'color': 'red' }}>*</font> 标签：</span>
            </WizCol>
            <WizCol span={12} className="modal-col-right">
              <WizRadio.Group defaultValue={1} onChange={(e) => { this.setState({ labelOperateType: e.target.value }) }}>
                <WizRadio value={1}>新增标签</WizRadio>
                <WizRadio value={2}>替换标签</WizRadio>
                <WizRadio value={3}>删除标签</WizRadio>
              </WizRadio.Group>
            </WizCol>
          </WizRow>
          {this.state.labelOperateType == 3 || this.state.labelOperateType == 2 ?
            <WizRow className="modal-row">
              <WizCol span={7} className="modal-col">
                <span><font style={{ 'color': 'red' }}>*</font> {oldLabledName}</span>
              </WizCol>
              <WizCol span={12} className="modal-col-right">
                <WizTableForm
                  onChange={(e) => { this.setState({ oldLabelIdList: e }) }}
                  key={'label1'} {...WizTableForm.Config.label(this, { apiParams: { type: 6, name: '产品知识库标签' ,idList:hasLableIds} })} />
              </WizCol>
            </WizRow> : <></>
          }
          {this.state.labelOperateType == 1 || this.state.labelOperateType == 2 ?
            <WizRow className="modal-row">
              <WizCol span={7} className="modal-col">
                <span><font style={{ 'color': 'red' }}>*</font> {newLableName}</span>
              </WizCol>
              <WizCol span={12} className="modal-col-right">
                <WizTableForm
                  onChange={(e) => { this.setState({ newLabelIdList: e }) }}
                  key={'label2'} {...WizTableForm.Config.label(this, { apiParams: { type: 6, name: '产品知识库标签' } })} />
              </WizCol>
            </WizRow> : <></>
          }
        </> : <></>}
      </div>
    </>
  }
}
const mapStateToProps = (state, ownProps) => {
  const { proKnowledge } = state;
  const batchUpdateInfo = modelUtils.getModelEntity(proKnowledge, "proKnowledge@batchUpdate");
  const load = modelUtils.getLoadingState(state, ['proKnowledge']);
  return {
    batchUpdateInfo: batchUpdateInfo,
    ...load
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(BatchUpdate)
